import { render, staticRenderFns } from "./StoryEditDialog.vue?vue&type=template&id=23ea5db1&scoped=true&"
import script from "./StoryEditDialog.vue?vue&type=script&lang=js&"
export * from "./StoryEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./StoryEditDialog.vue?vue&type=style&index=0&id=23ea5db1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea5db1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
